import React from 'react'
import CrownIcon from './CrownIcon'
import FireIcon from './FireIcon'
import SpeedometerIcon from './SpeedometerIcon'
import SproutIcon from './SproutIcon'

interface IconProps {
  size?: number
  color?: string
  className?: string
  title?: string
}

/**
 * Skill-level glyph, mirroring the mobile Player Finder's growth ramp:
 * sprout → speedometer → fire → crown (Beginner → Elite).
 *
 * Kept in sync with `getSkillLevelIcon` in
 * `common/features/playerFinder/skillLevelColor.ts`, which returns the
 * equivalent MaterialCommunityIcons names for mobile. That helper can't be
 * reused directly here because its values are RN icon-font names, not
 * components — but the level→glyph mapping and the neutral speedometer
 * fallback for an unknown level must match.
 */
const ICON_BY_SKILL: Record<string, React.FC<IconProps>> = {
  beginner: SproutIcon,
  intermediate: SpeedometerIcon,
  advanced: FireIcon,
  elite: CrownIcon,
}

const DEFAULT_ICON = SpeedometerIcon

export interface SkillLevelIconProps extends IconProps {
  skillLevel?: string | null
}

const SkillLevelIcon: React.FC<SkillLevelIconProps> = ({
  skillLevel,
  ...iconProps
}) => {
  const Icon = skillLevel
    ? ICON_BY_SKILL[skillLevel.trim().toLowerCase()] ?? DEFAULT_ICON
    : DEFAULT_ICON
  return <Icon {...iconProps} />
}

export default SkillLevelIcon
